import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Tab } from '../model/tab.model';


@Injectable()
export class LmsRendererService {

  windowHeight: number;
  windowWidth: number;

  resizeObervable: Observable<Boolean>;
  resizeBS: BehaviorSubject<Boolean>;

  historyOverlayObs: Observable<string>;
  historyOverlayBS: BehaviorSubject<string>;

  lastSelectedTab: Tab;
  lastSelectedTabObs: Observable<Tab>;
  lastSelectedTabSub: Subject<Tab>;

  constructor() {
    this.resizeBS = <BehaviorSubject<Boolean>>new BehaviorSubject({});
    this.resizeObervable = this.resizeBS.asObservable();
    this.historyOverlayBS = <BehaviorSubject<string>>new BehaviorSubject({});
    this.historyOverlayObs = this.historyOverlayBS.asObservable();
    this.lastSelectedTabSub = <Subject<Tab>>new Subject();
    this.lastSelectedTabObs = this.lastSelectedTabSub.asObservable();
  }

  setLastUrl(tab: Tab) {
    this.lastSelectedTab = tab;
    this.lastSelectedTabSub.next(tab);
  }

  getLastUrl(): Tab {
    return this.lastSelectedTab;
  }

  calculateHeightWidth() {
    this.windowHeight = window.innerHeight;
    this.windowWidth = window.innerWidth;
    this.resizeBS.next(true);
  }

  getWindowHeight() {
    return this.windowHeight;
  }

  getWindowWidth() {
    return this.windowWidth;
  }

  updateOverlayVisibility(overlayName: string) {
    this.historyOverlayBS.next(overlayName);
  }

}
